namespace $.$$ {

	export class $shm_hitalama_map_widget_tools_link_pick extends $.$shm_hitalama_map_widget_tools_link_pick {

		override showed( next?: boolean ) {
			const showed = super.showed( next )
			if( next === true ) new this.$.$mol_after_frame( ()=> {
				new this.$.$mol_after_frame( ()=> {
					if( this.showed() ) this.Input().focused( true )
				} )
			} )
			return showed
		}

	}

}
